export const SET_STATISTIC_ORDER_FILTER = 'SET_STATISTIC_ORDER_FILTER';
export const RESET_STATISTIC_ORDER_FILTER = 'RESET_STATISTIC_ORDER_FILTER';

export const SET_TABLE_LIST = 'SET_TABLE_LIST';
export const SET_TABLE_PAGE_INFO = 'SET_TABLE_PAGE_INFO';
export const RESET_TABLE_PAGE_INFO = 'RESET_TABLE_PAGE_INFO';

export const SET_ESTIMATE_COMMISSION = 'SET_ESTIMATE_COMMISSION';
export const SET_SETTLE_MEDIA = 'SET_SETTLE_MEDIA';
export const GET_DOWNLOAD = 'GET_DOWNLOAD';
export const GET_DOWNLOAD_BILL = 'GET_DOWNLOAD_BILL';
export const GET_DOWNLOAD_BILL_MULI = 'GET_DOWNLOAD_BILL_MULI';
export const SET_ACCOUNT_TYPE = 'SET_ACCOUNT_TYPE';
